import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Fournisseur} from '../../../../../domain/fournisseur/fournisseur';
import {FormControl, Validators} from '@angular/forms';
import {InscriptionfournisseurFormService} from '../../inscriptionfournisseur-form.service';
import {isEmpty} from '../../../../../utils/is-empty';
import {CustomValidators} from '../../../../../forms/validators';

@Component({
    selector: 'app-add-info-responsable',
    templateUrl: './add-info-responsable.component.html',
    styleUrls: ['./add-info-responsable.component.css'],
    providers: [InscriptionfournisseurFormService],
})
export class AddInfoResponsableComponent implements OnInit {
    form = this.formService.createRespForm();
    @Input() fournisseur?: Fournisseur;
    @Input() data?: any;
    fields = this.formService.fields;
    @Output() next = new EventEmitter<any>();

    constructor(private formService: InscriptionfournisseurFormService) {
    }

    get currentDate() {
        return new Date();
    }

    ngOnInit(): void {

    }

    get(key: string) {
        return this.form.controls['umRcvChief'].get(key) as FormControl;
    }

    onSubmit(f?: Fournisseur) {
        f = this.form.value;
        this.next.emit(f);
    }

    setlable() {
        if (this.data == 'TUN' && !isEmpty(this.data)) {
            this.get('indRegNo').clearValidators();

            this.get('indRegNo').setValidators([
                Validators.required,
                CustomValidators.isCin(),
            ]);
            this.form.updateValueAndValidity();

            return 'N° de CIN';
        } else if (this.data == 'Autre' && !isEmpty(this.data)) {
            this.get('indRegNo').clearValidators();

            this.get('indRegNo').setValidators(Validators.required);
            this.form.updateValueAndValidity();
            return 'N° de Passport';
        }
    }
}
